<template>
	<div class="m-1">
		<b-modal ref="wait-modal" size="mg" id="modal-center" centered hide-footer  hide-title
			title="...">
			<div class="d-flex justify-content-center p-2">
				<span>您支付过于频繁，需要等待<b class="text-danger" style="font-size: 24px;">{{leftime}}</b>秒才可以支付!</span>
			</div>
		</b-modal>
	</div>
</template>
<script>

	export default {
		components: {
		},
		data() {
			return {
				leftime:0,
				waitTimer:0,
				callBack:null,
			}
		},

		methods: {
			changeTime(){
				if(this.leftime==1){
					this.hideModal()
					this.callBack()
				}
				this.leftime=this.leftime-1
			},
			showModal(_leftime,_callBack) {
				let that=this;
				this.callBack=_callBack;
				this.leftime=_leftime
				this.$refs['wait-modal'].show()
				this.$forceUpdate()
				if(this.waitTimer>0){
					clearInterval(this.waitTimer)
				}
				this.waitTimer = setInterval(function() {
					that.changeTime()
				}, 1000);
	
			},
			
			hideModal() {
				this.$refs['wait-modal'].hide()
			},
		}

	}
</script>

<style>

</style>
